import BaseExpandableCard from 'ui/components/BaseExpandableCard'
import ExpandableCardBody from 'ui/components/BaseExpandableCard/components/ExpandableCardBody'
import ExpandableCardHeader from 'ui/components/BaseExpandableCard/components/ExpandableCardHeader'
import Button from 'ui/components/buttons/Button/'
import TaskTypeBadge from 'ui/components/TaskTypeBadge'
import { ButtonWrap, DetailsContainer } from './styled'

const TemplatesSelectItem = ({
  id,
  name,
  tag,
  template,
  expanded,
  onToggle,
  onApply,
}) => {
  return (
    <BaseExpandableCard
      id={id}
      iconPosition="left"
      iconGap={8}
      expanded={expanded}
      onToggle={onToggle}
      header={
        <ExpandableCardHeader
          badge={<TaskTypeBadge taskType={tag} variant="template" />}
          title={name}
          right={
            <ButtonWrap>
              <Button
                title="Применить"
                type="button"
                theme="borderBlue"
                onClick={(e) => {
                  e.stopPropagation()
                  onApply()
                }}
              />
            </ButtonWrap>
          }
        />
      }
    >
      <DetailsContainer>
        <ExpandableCardBody template={template} compactPreview />
      </DetailsContainer>
    </BaseExpandableCard>
  )
}

export default TemplatesSelectItem
